import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import StateExplorer from "@/pages/StateExplorer";
import StateDetail from "@/pages/StateDetail";
import International from "@/pages/International";
import Claims from "@/pages/Claims";
import WaterCooling from "@/pages/WaterCooling";
import Methodology from "@/pages/Methodology";
import Advertise from "@/pages/Advertise";
import AdvertisePricing from "@/pages/AdvertisePricing";
import AdvertiseSignup from "@/pages/AdvertiseSignup";
import PaymentResult from "@/pages/PaymentResult";
import NewsletterPage from "@/pages/NewsletterPage";
import Newsroom from "@/pages/Newsroom";
import Privacy from "@/pages/Privacy";
import Confirm from "@/pages/Confirm";
import Unsubscribe from "@/pages/Unsubscribe";
import Preferences from "@/pages/Preferences";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PowerStudy from "@/pages/PowerStudy";
import Account from "@/pages/Account";
import PowerStudySample from "@/pages/PowerStudySample";
import GoogleAuthCallback from "@/components/GoogleAuthCallback";

const Site = ({ children }) => <Layout>{children}</Layout>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return (
        <Routes>
          <Route path="/power-study" element={<Site><PowerStudy /></Site>} />
          <Route path="/power-study/sample" element={<Site><PowerStudySample /></Site>} />
          <Route path="/power-study/success" element={<Site><PaymentResult /></Site>} />
          <Route path="/power-study/cancel" element={<Site><PaymentResult /></Site>} />
          <Route path="/account" element={<Site><Account /></Site>} />
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/states" element={<Site><StateExplorer /></Site>} />
          <Route path="/states/:abbr" element={<Site><StateDetail /></Site>} />
          <Route path="/international" element={<Site><International /></Site>} />
          <Route path="/claims" element={<Site><Claims /></Site>} />
          <Route path="/water-cooling" element={<Site><WaterCooling /></Site>} />
          <Route path="/methodology" element={<Site><Methodology /></Site>} />
          <Route path="/advertise" element={<Site><Advertise /></Site>} />
          <Route path="/advertise/pricing" element={<Site><AdvertisePricing /></Site>} />
          <Route path="/advertise/signup" element={<Site><AdvertiseSignup /></Site>} />
          <Route path="/payment/success" element={<Site><PaymentResult /></Site>} />
          <Route path="/payment/cancel" element={<Site><PaymentResult /></Site>} />
          <Route path="/newsletter" element={<Site><NewsletterPage /></Site>} />
          <Route path="/newsroom" element={<Site><Newsroom /></Site>} />
          <Route path="/privacy" element={<Site><Privacy /></Site>} />
          <Route path="/confirm" element={<Site><Confirm /></Site>} />
          <Route path="/unsubscribe" element={<Site><Unsubscribe /></Site>} />
          <Route path="/preferences" element={<Site><Preferences /></Site>} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
